<template>
  <com-page>
    <com-card>
      <div class="form-item">
        <div class="form-item-label">是否低消：</div>
        <el-radio-group v-model="form.open">
          <el-radio-button label="1">是</el-radio-button>
          <el-radio-button label="0">否</el-radio-button>
        </el-radio-group>
      </div>
      <div class="form-item">
        <div class="form-item-label">低消标准：</div>
        <div class="input-box">
          <div class="input-box-item">
            <div class="input-item-label">计费开始</div>
            <el-input v-model="form.offsetStartTime" placeholder="请输入计费开始时间">
              <template slot="append">分钟</template>
            </el-input>
          </div>
          <div class="input-box-item">
            <div class="input-item-label">免费次数</div>
            <el-input v-model="form.freeTimes" placeholder="请输入免费次数">
              <template slot="append">次</template>
            </el-input>
          </div>
          <div class="input-box-item">
            <div class="input-item-label">最低消费</div>
            <el-input v-model="form.minConsumption" placeholder="请输入最低消费">
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
      </div>

      <div class="footer">
        <el-button type="primary" :loading="btnLoading" @click="saveInfo">保存</el-button>
      </div>
    </com-card>
  </com-page>
</template>

<script>
import { getLowConsumptionConfig, updateLowConsumptionConfig } from '@/api/low-consumption-mode'

export default {
  data() {
    return {
      btnLoading: false,
      form: {
        open: '',
        offsetStartTime: '',
        freeTimes: '',
        minConsumption: '',
      }
    }
  },

  created() {
    this.getDetail()
  },

  methods: {
    getDetail() {
      getLowConsumptionConfig({}).then((res) => {
        console.log('查询配置成功', res)
        this.form = res.data.result
      })
    },

    saveInfo() {
      this.btnLoading = true
      updateLowConsumptionConfig(this.form).then((res) => {
        this.btnLoading = false
        this.$message.success('保存成功')
      }).catch(err => {
        this.btnLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  .form-item-label {
    margin-right: 15px;
  }
  .input-box {
    display: flex;
    align-items: center;
    .input-box-item {
      margin-right: 60px;
      display: flex;
      align-items: center;
      .input-item-label {
        flex-shrink: 0;
        font-size: 14px;
        margin-right: 10px;
      }
    }
  }
}
</style>
